import { Box, Collapse, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles(() => {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        title: {
            opacity: 0.8,
            flexGrow: 1,
        },
        titleMobile: {
            marginBottom: 0,
        },
    };
});

export const FooterSectionItem: React.FC<{ title: string }> = ({ title, children }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
    const [collapsed, setCollapsed] = useState(false);
    const toggleCollapse = (): void => setCollapsed((prev) => !prev);
    useEffect(() => {
        if (isMobile) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
        }
    }, [isMobile]);
    return (
        <>
            <Box className={classes.root}>
                <Typography
                    variant="h5"
                    className={clsx(classes.title, isMobile && classes.titleMobile)}
                    onClick={() => {
                        if (isMobile) {
                            toggleCollapse();
                        }
                        return;
                    }}
                    style={{ cursor: isMobile ? 'pointer' : 'default' }}
                >
                    {title}
                </Typography>
                {isMobile && (
                    <ExpandMoreIcon
                        style={{
                            transition: '.3s',
                            transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                            cursor: 'pointer',
                        }}
                        onClick={toggleCollapse}
                    />
                )}
            </Box>
            <Collapse in={!collapsed}>
                <Box width="fit-content">{children}</Box>
            </Collapse>
        </>
    );
};
